import { Link } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { IconRubInCircle } from '../../icon/IconRubInCircle';
import { Button } from '../../input/Button';
import { Typography } from '../../typography/Typography';
import { ADVERTISING_CATALOG_URL } from './constants';
import type { AdvertisingButtonProps } from './types';

export const AdvertisingButton: React.FC<AdvertisingButtonProps> = ({
    text,
    target = '_blank',
    ...other
}) => {
    const t = useTranslation();

    return (
        <Button
            as={Link}
            target={target}
            size="m"
            variant="filled"
            color="secondary"
            spacing={0.5}
            to={ADVERTISING_CATALOG_URL}
            {...other}
        >
            <IconRubInCircle size={20} />
            <Typography variant="caption" weight="bold" letterSpacing="0.7px" color="inherit">
                {text ?? t('Монетизация')}
            </Typography>
        </Button>
    );
};
